import * as React from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	CircularProgress
} from '@mui/material';

export default function ConfirmationDialog({
	open,
	title,
	message,
	itemName,
	onClose,
	onConfirm,
	isLoading = false,
	isDownloadConfirmation = false,
	handleExcelDownload,
	handleDownloadPDF
}: {
	open: boolean;
	title: string;
	message: string;
	itemName?: string;
	onClose: () => void;
	onConfirm: () => void;
	handleExcelDownload?: () => void;
	handleDownloadPDF?: () => void;
	isLoading?: boolean;
	isDownloadConfirmation?: boolean;
}) {
	const dialogMessage = itemName ? (
		<>
			{message.replace(/\?$/, '')}{' '}
			<strong>&quot;{itemName}&quot;</strong>?
		</>
	) : (
		message
	);
	return (
		<React.Fragment>
			<Dialog
				open={open}
				onClose={(_, reason) => {
					if (isLoading) return;
					// Block accidental close from backdrop/escape while request is in-flight.
					if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
					onClose();
				}}
				disableEscapeKeyDown={isLoading}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
				<DialogContent className={isDownloadConfirmation && 'w-[400px]'}>
					<DialogContentText id="alert-dialog-description">{dialogMessage}</DialogContentText>
				</DialogContent>
				{isDownloadConfirmation ? <DialogActions className='mr-3 mb-3'>
					<Button
						onClick={handleExcelDownload}
						variant="outlined"
						color="secondary"
					>
						Excel
					</Button>
					<Button
						onClick={handleDownloadPDF}
						autoFocus
						variant="contained"
						color="secondary"
						disabled={isLoading}
						startIcon={isLoading && <CircularProgress size={20} />}
					>
						PDF
					</Button>
				</DialogActions> :
				<DialogActions className='mr-3 mb-3'>
					<Button
						onClick={onClose}
						variant="outlined"
						color="secondary"
						disabled={isLoading}
					>
						Cancel
					</Button>
					<Button
						onClick={onConfirm}
						autoFocus
						variant="contained"
						color="secondary"
						disabled={isLoading}
						startIcon={isLoading && <CircularProgress size={20} />}
					>
						Confirm
					</Button>
				</DialogActions>}
			</Dialog>
		</React.Fragment>
	);
}
